import { motion } from 'framer-motion';

export function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-primary py-28 md:py-40">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -left-4 top-0 h-72 w-72 rounded-full bg-secondary blur-3xl" />
        <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-secondary blur-3xl" />
      </div>

      <div className="container relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mx-auto flex max-w-4xl justify-center"
        >
          <img
            src="/n4-logo.webp"
            alt="N4 Research Group – Nutrition, Neurodevelopment, Neonatology, NorthPop"
            className="max-w-md brightness-0 invert md:max-w-xl lg:max-w-2xl"
            width={672}
            height={200}
            loading="eager"
            fetchPriority="high"
          />
        </motion.div>
      </div>
    </section>
  );
}
